import { z } from 'zod';

export const OptionSchema = z.object({
    id: z.string(),
    label: z.string(),
    exampleValues: z.array(z.union([z.string(), z.number()])).catch([]),
});
export type OptionType = z.infer<typeof OptionSchema>;

export const ColumnElementSelectSchema = z.object({
    type: z.literal('select'),
    error: z.string().default(''),
    warning: z.string().default(''),
    section: z.string(),
    required: z.boolean().default(false),
    multi: z.boolean().default(false),
    visible: z.boolean().default(true),
    id: z.string(),
    label: z.string(),
    selectedOptionId: z.string(),
    availableOptions: z.array(z.string()),
    optionsErrors: z
        .array(
            z.object({
                id: z.string(),
                message: z.string(),
            })
        )
        .catch([]),
    optionsWarnings: z
        .array(
            z.object({
                id: z.string(),
                message: z.string(),
            })
        )
        .catch([]),
});
export type ColumnElementSelectType = z.infer<typeof ColumnElementSelectSchema>;

export const ColumnElementCheckboxSchema = z.object({
    section: z.string(),
    type: z.literal('checkbox'),
    id: z.string(),
    label: z.string(),
    checked: z.boolean().catch(false),
    enabled: z.boolean().catch(false),
});
export type ColumnElementCheckboxType = z.infer<typeof ColumnElementCheckboxSchema>;

export type CallbacksType = {
    onValidate: (valid: boolean, reasons: string[]) => void;
};

export const SectionSchema = z.object({
    id: z.string(),
    label: z.string(),
});
export type SectionType = z.infer<typeof SectionSchema>;

export const ColumnElementSchema = z.union([ColumnElementSelectSchema, ColumnElementCheckboxSchema]);
export type ColumnElementType = z.infer<typeof ColumnElementSchema>;

export const ColumnSettingsSchema = z.object({
    elements: z.array(ColumnElementSchema),
    sections: z.array(SectionSchema),
    options: z.array(OptionSchema),
    errors: z.array(z.string()).catch([]),
    warnings: z.array(z.string()).catch([]),
});
export type ColumnSettingsType = z.infer<typeof ColumnSettingsSchema>;
